import TweenLite from 'TweenLite';
import scrollBarWidth from './scrollBarWidth';

class Helper {
    constructor() {
        /**
         * @property {number}
         * @return {boolean}
         */
        this.isMobile = this.mobileCheck();
    }

    /**
     * @return {number}
     * @description размер скроллбара
     */
    scrollBarWidth() {
        return scrollBarWidth();
    }

    mobileCheck() {
        let check =
            (function (a) {
                if (
                    /(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                        a
                    ) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                        a.substr(0, 4)
                    )
                )
                    return true;
            })(navigator.userAgent || navigator.vendor || window.opera) ||
            false;
        if (check) {
            document.body.classList.add('mobile-device');
        }
        return check;
    }

    /**
     * @param {string|number}
     * @return {string}
     * @description возвращает форматированную строку вида 1 000 000
     */
    formatDecimals(input) {
        let i = input.toString();
        return i.replace(/(\d{1,3}(?=(\d{3})+(?:\.\d|\b)))/g, '$1 ');
    }

    /**
     * @param {object} el
     * @param {string} message
     */
    showFieldError(el, message) {
        if (!el) return;
        if (el instanceof $) {
            el.addClass('sst-field--has-error')
                .siblings('.sst-field__error')
                .html(message);
        } else {
            el.classList.add('sst-field--has-error');
            let errorField = el.parentNode.querySelectorAll(
                '.sst-field__error'
            )[0];
            if (errorField) errorField.innerHTML = message;
        }
    }

    /**
     * @param {number} number - сколько стульев
     * @param {array} titles ['стул', 'стула', 'стульев']
     * @return {string}
     * @description Склонение
     */
    declension(number, titles) {
        let cases = [2, 0, 1, 1, 1, 2];
        return titles[
            number % 100 > 4 && number % 100 < 20
                ? 2
                : cases[number % 10 < 5 ? number % 10 : 5]
        ];
    }

    /**
     * @description Блокирует страницу
     */
    freezeDocument() {
        // if( document.querySelectorAll('.overlay-block') !== null ) return
        let element = document.createElement('div');
        element.className = 'overlay-block';
        element.style.position = 'fixed';
        element.style.top = 0;
        element.style.left = 0;
        element.style.right = 0;
        element.style.bottom = 0;
        element.style.opacity = 0;
        element.style.zIndex = 20000;
        return document.body.appendChild(element);
    }

    /**
     * @description Разблокирует страницу
     */
    unFreezeDocument() {
        let elements = document.querySelectorAll('.overlay-block');
        return (function () {
            [].forEach.call(elements, function (element) {
                element.parentNode.removeChild(element);
            });
        })();
    }

    /**
     * @description Событие окончания CSS transition
     */
    whichTransitionEvent() {
        let el = document.createElement('fakeelement');
        let transitions = {
            transition: 'transitionend',
            OTransition: 'oTransitionEnd',
            MozTransition: 'transitionend',
            WebkitTransition: 'webkitTransitionEnd',
        };
        for (let t in transitions) {
            if (el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    }

    /**
     * @description Событие окончания CSS animation
     */
    whichAnimationEvent() {
        let el = document.createElement('fakeelement2');
        let animations = {
            animation: 'animationend',
            OAnimation: 'oAnimationEnd',
            MozAnimation: 'animationend',
            WebkitAnimation: 'webkitAnimationEnd',
        };
        for (let t in animations) {
            if (el.style[t] !== undefined) {
                return animations[t];
            }
        }
    }

    /**
     * @param {object} element
     * @param {number} animationDuration
     * @param {function} callback
     * @description Показывает element
     */
    slideDown(element, animationDuration, callback) {
        if (animationDuration == null || typeof animationDuration != 'number') {
            animationDuration = 0.3;
        }
        if (typeof TweenLite === undefined) {
            throw new Error('Helper requires GSAP Tweenlite');
        }
        TweenLite.set(element, { overflow: 'hidden' });
        TweenLite.killTweensOf(element, true);
        TweenLite.set(element, {
            display: 'block',
            height: 'auto',
            autoAlpha: 1,
        });
        TweenLite.from(element, animationDuration, {
            display: 'none',
            height: '0',
            autoAlpha: 0,
            onComplete: function () {
                if (callback != null) {
                    callback();
                }
                TweenLite.set(element, { overflow: '' });
            },
        });
    }

    /**
     * @param {object} element
     * @param {number} animationDuration
     * @param {function} callback
     * @description Скрывает element
     */
    slideUp(element, animationDuration, callback) {
        if (animationDuration == null || typeof animationDuration != 'number') {
            animationDuration = 0.3;
        }
        if (typeof TweenLite === undefined) {
            throw new Error('Helper requires GSAP Tweenlite');
        }
        TweenLite.set(element, { overflow: 'hidden' });
        TweenLite.killTweensOf(element, true);
        TweenLite.to(element, animationDuration, {
            display: 'none',
            height: '0',
            autoAlpha: 0,
            onComplete: function () {
                if (callback != null) {
                    callback();
                }
                TweenLite.set(element, { overflow: 'auto' });
            },
        });
    }

    /**
     * @description Вызывает событие
     * @param {object} elem
     * @param {string} Название события
     */
    triggerEvent(elem, event) {
        let ev = document.createEvent('HTMLEvents');
        ev.initEvent(event, true, false);
        return elem.dispatchEvent(ev);
    }
}

export default new Helper();
